<template>
  <v-container fluid class="py-0">
    <div>{{ label }}</div>
    <v-list dense>
      <v-list-item-group color="primary">
        <v-list-item v-for="(item,i) in items" :key="i" @click="onChange(item.value)">
          <v-list-item-title>{{item.text}}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <!-- <v-radio-group hide-details @change="onChange" :value="value" :mandatory="true" class="mt-0">
      <v-row no-gutters>
        <v-col v-for="item,i in items" :key="i" cols="12" xs="12" sm="6" md="4">
          <v-radio :label="item.text" :value="item.value"></v-radio>
        </v-col>
      </v-row>
    </v-radio-group>-->
    <div v-if="error" class="error--text">
      <small>{{ errorMessages }}</small>
    </div>
  </v-container>
</template>

<script>
import _ from "lodash";

export default {
  props: ["label", "items", "value", "error", "error-messages"],

  methods: {
    onChange: function(value) {
      this.$emit("input", value);
    }
  },

  mounted: function() {
    if (!this.$props.value) this.$nextTick().then(this.$forceUpdate());
  }
};
</script>